import type { ForwardedRef } from "react";

import * as sx from "./index.sx";

export interface ISpinnerProps {
  size?: number;
  className?: string;
  "data-testid"?: string;
  centered?: boolean;
  ref?: ForwardedRef<HTMLDivElement>;
}

export const Spinner = ({ centered, ...props }: ISpinnerProps) => {
  return (
    <sx.SizedBox size={centered ? "100%" : `${props.size ?? 40}px`}>
      <sx.Spinner {...props} className={props.className} />
    </sx.SizedBox>
  );
};
